import React from "react";
import "./TopPicks.css";
import { FaArrowRight } from "react-icons/fa";

// Import your product images
import lipstickImage from "../../Images/lipstick2.jpg";
import eyelinerImage from "../../Images/eyeliner2.jpg";
import blushImage from "../../Images/blush2.jpg";
import foundationImage from "../../Images/Foundation.jpg";

const productsData = [
  {
    id: 1,
    number: "01",
    title: "LIPSTICK",
    description:
      "Swipe on confidence with rich, lasting color—discover your perfect lipstick shade for every mood and moment.",
    image: lipstickImage,
  },
  {
    id: 2,
    number: "02",
    title: "EYELINER",
    description:
      "Define your look with precision and drama. Our long-lasting eyeliner glides on smoothly for a bold, flawless finish.",
    image: eyelinerImage,
  },
  {
    id: 3,
    number: "03",
    title: "BLUSH",
    description:
      "Add a natural flush of color to your cheeks. Our blendable blush creates a radiant, healthy glow that lasts all day.",
    image: blushImage,
  },
  {
    id: 4,
    number: "04",
    title: "FOUNDATION",
    description:
      "Achieve flawless coverage with our foundation range. From natural to full coverage, find your perfect match for radiant skin.",
    image: foundationImage,
  },
];

const TopPicks = () => {
  return (
    <section className="top-picks-section">
      <div className="top-picks-overlay"></div>
      
      <div className="top-picks-content">
        <div className="top-picks-header">
          <h1>TOP PICKS</h1>
          <p>JUST FOR YOU</p>
        </div>

        <div className="products-grid">
          {productsData.map((product) => (
            <div key={product.id} className="product-card">
              <div className="product-image-wrapper">
                <div className="product-number-badge">{product.number}</div>
                <img src={product.image} alt={product.title} />
              </div>
              
              <div className="product-details">
                <h3 className="product-title">{product.title}</h3>
                <p className="product-description">{product.description}</p>
                <button className="product-explore-btn">
                  EXPLORE <FaArrowRight className="explore-arrow" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TopPicks;
